const t = null;
export {
  t as default
};
//# sourceMappingURL=index.es244.js.map
